export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-flickr-ed89e8296fa63f2c7c5a8aba3145465b.svg";